import React, { useContext } from "react";
export var BreakpointContext = /*#__PURE__*/React.createContext();

function useBreakpoint() {
  var breakpoint = useContext(BreakpointContext);
  return breakpoint;
}

export default useBreakpoint;